import React, { useState } from "react";
import "./ExportChat.css";

const ExportChat = ({ messages, sessionTitle }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [copied, setCopied] = useState(false);

  const getFormattedChat = (format) => {
    const title = sessionTitle || "Zanox Session";
    const date = new Date().toLocaleString();
    
    if (format === "markdown") {
      let md = "# " + title + "\n\n";
      md += "*Exported: " + date + "*\n\n---\n\n";
      messages.forEach((msg) => {
        const role = msg.role === "user" ? "**You**" : "**Zanox**";
        md += "### " + role + "\n\n";
        md += (msg.content || "") + "\n\n---\n\n";
      });
      return md;
    }

    if (format === "text") {
      let txt = title + "\n";
      txt += "=".repeat(title.length) + "\n";
      txt += "Exported: " + date + "\n\n";
      messages.forEach((msg) => {
        const role = msg.role === "user" ? "YOU" : "ZANOX";
        txt += "[" + role + "]\n";
        txt += (msg.content || "") + "\n\n";
      });
      return txt;
    }

    if (format === "json") {
      return JSON.stringify({
        title,
        exportedAt: date,
        messages: messages.map((msg) => ({
          role: msg.role,
          content: msg.content,
          timestamp: msg.timestamp || "",
        })),
      }, null, 2);
    }

    return "";
  };

  const handleExport = (format) => {
    const content = getFormattedChat(format);
    
    if (format === "json") {
      const blob = new Blob([content], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "zanox-chat-" + Date.now() + ".json";
      a.click();
      URL.revokeObjectURL(url);
      setShowMenu(false);
      return;
    }
    navigator.clipboard.writeText(content).then(() => {
      setCopied(true);
      setTimeout(() => { setCopied(false); setShowMenu(false); }, 1500);
    }).catch(() => {
      const ta = document.createElement("textarea");
      ta.value = content;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => { setCopied(false); setShowMenu(false); }, 1500);
    });
  };

  if (!messages || messages.length === 0) return null;

  return (
    <div className="export-chat">
      <button
        className="export-btn"
        onClick={() => setShowMenu(!showMenu)}
        title="Export chat"
      >
        <i className="fas fa-download"></i>
        <span>Export</span>
      </button>

      {showMenu && (
        <div className="export-menu">
          <button onClick={() => handleExport("markdown")}>
            <i className="fab fa-markdown"></i>
            <span>Copy as Markdown</span>
          </button>
          <button onClick={() => handleExport("text")}>
            <i className="fas fa-file-alt"></i>
            <span>Copy as Plain Text</span>
          </button>
          <button onClick={() => handleExport("json")}>
            <i className="fas fa-code"></i>
            <span>Download JSON</span>
          </button>
        </div>
      )}

      {copied && <div className="export-toast"><i className="fas fa-check"></i> Copied</div>}
    </div>
  );
};

export default ExportChat;
